import { type FC, type Ref } from "react";
import { type ClientImage } from "@clientFrontend/features/publication/components/ClientImageLibraryModal/type";
import { ClientImageCassette } from "@clientFrontend/features/publication/components/ClientImageLibraryModal/uiParts/ClientImageCassette";
import * as styles from "./styles.css";

type Props = {
  selectedImageIds: number[];
  visibleClientImages: ClientImage[];
  scrollTargetRef: Ref<HTMLDivElement>;
  handleClickClientImageCassette: (clientImage: ClientImage) => void;
};

export const Presentation: FC<Props> = ({
  selectedImageIds,
  visibleClientImages,
  scrollTargetRef,
  handleClickClientImageCassette,
}) => {
  return (
    <div className={styles.wrapper}>
      {visibleClientImages.map((clientImage) => {
        // 「選択中」ラベルの制御
        const isSelected = selectedImageIds.includes(clientImage.id);

        return (
          <div key={clientImage.id}>
            <ClientImageCassette
              clientImage={{
                ...clientImage,
                isSelected,
              }}
              handleClickClientImageCassette={handleClickClientImageCassette}
            />
          </div>
        );
      })}
      <div ref={scrollTargetRef} className={styles.scrollTargetRef} />
    </div>
  );
};
